import {svgIconWrapper} from '../svg-icon-wrapper';

import BookRegular from './book-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props: Props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <BookRegular {...validProps} />;
}

SvgComponent.iconName = 'bookRegular';

export const BookRegularIcon = svgIconWrapper(SvgComponent);
